import { fg } from '@atlassian/jira-feature-gating';

const JiraAssignableAgentSessionExperienceRelayprovider = {
	get(): boolean {
		return fg('jira_assignable_agent_session_experience');
	},
};

export default JiraAssignableAgentSessionExperienceRelayprovider;
